export const orderByHotelList = [
  {
    label: 'Best',
    value: 'Recommended',
  },
  {
    label: 'Dist',
    value: 'distance',
  },
  {
    label: 'Price',
    value: 'price',
  },
  {
    label: 'Stars',
    value: 'RealRating',
  },
  {
    label: 'Reviews',
    value: 'ReviewRating',
  },
];

export const orderByCarList = [
  {
    label: 'Price',
    value: 'MinimumfarePerDay',
  },
  {
    label: 'Distance',
    value: 'PickupDistance',
  },
  {
    label: 'Company',
    value: 'VendorName',
  },
  {
    label: 'Type',
    value: 'Class',
  },
];

export const orderByAirList = [
  {
    label: 'Price',
    value: 'TotalAmount',
  },
  {
    label: 'Depart',
    value: 'FilterDepart',
  },
  {
    label: 'Arrive',
    value: 'FilterArrival',
  },
  {
    label: 'Duration',
    value: 'FilterDuration',
  },
];

export const orderByRailList = [
  {
    label: 'Price',
    value: 'amountToDisplay',
  },
  {
    label: 'Depart',
    value: 'departureTime',
  },
  {
    label: 'Arrive',
    value: 'arrivalTime',
  },
  {
    label: 'Duration',
    value: 'durationTime',
  },
];
